import { useState } from "react";
import { State } from "../types";
import { Action } from "./useHabitState";
import { shareJson } from "../api/share";
import { defaultHabits, defaultContexts, defaultCategories } from "../defaultValues";
import { importDataFromFile } from "../utils/importData";

export const useDataActions = (dispatch: React.Dispatch<Action>) => {
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);

  const handleExportData = (state: State) => {
    shareJson({
      jsonData: state,
      filename: "habitTrackerData.json"
    });
  };

  const handleImportData = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      try {
        const result = await importDataFromFile(file);
        if (result.success && result.data) {
          dispatch({ type: "LOAD_DATA", payload: result.data });
        } else {
          alert(result.error || "Failed to import data.");
        }
      } catch (error) {
        alert("An unexpected error occurred while importing data.");
      }
    }
  };

  const handleResetData = () => {
    dispatch({
      type: "LOAD_DATA",
      payload: {
        heatmapEnabled: false,
        reportPeriod: "2weeks",
        habits: defaultHabits,
        days: [],
        contexts: defaultContexts,
        categories: defaultCategories,
        sortOrder: "alphabetical",
        greyOutEnabled: true,
        contextsEnabled: true,
        notesEnabled: true,
        categoriesEnabled: false
      }
    });
    setResetConfirmOpen(false);
  };

  const handleResetConfirm = () => {
    setResetConfirmOpen(true);
  };

  const handleResetCancel = () => {
    setResetConfirmOpen(false);
  };

  return {
    resetConfirmOpen,
    handleExportData,
    handleImportData,
    handleResetData,
    handleResetConfirm,
    handleResetCancel,
  };
};